var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{staticClass:"mt-2",attrs:{"group":"mensagens"}}),_c('router-view'),_c('FooterComponent',{attrs:{"softwareVersion":_vm.softwareVersion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }